// DEPRECATED: work on removing these functions and/or moving to utils.js


import { createContext, useState, useEffect, useContext } from 'react'
import { atom, useAtom } from 'jotai'


export const UserSession = atom(null)


// Get the user session
const UserContext = createContext()

export function UserProvider({ children }) {
    const [user, setUser] = useState(null)

    return (
        <UserContext.Provider value={{ user, setUser }}>
            {children}
        </UserContext.Provider>
    )
}

export function useUser() {
    const context = useContext(UserContext)
    if (context === undefined) {
        throw new Error('useUser must be used within a UserProvider')
    }
    return context
}


// Save user account data
const AccountsContext = createContext();

export const AccountsProvider = ({ children, user }) => {
    const [accounts, setAccounts] = useState([]);

    useEffect(() => {
        if (user) {
            setAccounts([{
                id: user.$id,
                name: user.name,
                email: user.email,
                image: user.image || null,
                color: '#61b593',
                projects: user.projects || [],
            }]);
        }
    }, [user]);

    return (
        <AccountsContext.Provider value={accounts}>
            {children}
        </AccountsContext.Provider>
    );
};

export const useAccounts = () => {
    return useContext(AccountsContext);
};



// Set user sessions
export const setSession = () => {
    const [userSession, setUserSession] = useAtom(UserSession);

    const updateUserSession = (newUser) => {
        setUserSession((prevSession) => {
            const updatedSession = newUser;
            console.log("Updated UserSession:", updatedSession);
            return updatedSession;
        });
    };

    return {
        userSession,
        updateUserSession,
    };
};

// Get user sessions (is this still needed?)
export const getSession = () => {
    const [userSession] = useAtom(UserSession);
    return userSession;
};

